import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CardV2 } from "../../../components/CardV2/CardV2";
import Toggle from "../../../components/Toggle/Toggle";
import PriceField from "../../../components/PriceField/PriceField";
import CONFIG from "../../../config/config";
import PaymentsNotice from "../../../components/PaymentsNotice/PaymentsNotice";

interface FeesSectionProps {
  contractTemplate: any;
  updateContractTemplate: (value: any) => void;
}

export default function FeesSection({ contractTemplate, updateContractTemplate }: FeesSectionProps) {
  const { t } = useTranslation();
  const [isDropFeePaid, setIsDropFeePaid] = useState((contractTemplate.dropFee?.price ?? 0) > 0);
  const [isRenewalFeePaid, setIsRenewalFeePaid] = useState((contractTemplate.renewalFee?.price ?? 0) > 0);

  useEffect(() => {
    setIsDropFeePaid((contractTemplate.dropFee?.price ?? 0) > 0);
  }, [contractTemplate.dropFee?.price]);

  useEffect(() => {
    setIsRenewalFeePaid((contractTemplate.renewalFee?.price ?? 0) > 0);
  }, [contractTemplate.renewalFee?.price]);

  return (
    <CardV2>
      <div className="p-4 space-y-6">
        <div>
          <label className="block mb-2 font-medium">{t('commission_contract_template.drop_fee_label')}</label>
          <div className="flex items-center gap-4 mb-2">
            <Toggle
              label={isDropFeePaid ? t('commission_contract_template.drop_fee.paid') || '' : t('commission_contract_template.drop_fee.free') || ''}
              defaultValue={isDropFeePaid}
              onChange={(checked: boolean) => {
                setIsDropFeePaid(checked);
                if (!checked) {
                  updateContractTemplate({ dropFee: { price: 0, currency: contractTemplate.dropFee?.currency ?? 'EUR' } });
                }
              }}
            />
            {isDropFeePaid ? (
              <div className="flex items-center gap-2 w-full max-w-xs">
                <PriceField
                  label={''}
                  price={contractTemplate.dropFee?.price ?? 0}
                  currency={contractTemplate.dropFee?.currency ?? 'EUR'}
                  currencies={CONFIG.SUPPORTED_CURRENCIES}
                  onCurrencyChange={currency => updateContractTemplate({ dropFee: { price: contractTemplate.dropFee?.price ?? 0, currency } })}
                  onPriceChange={price => updateContractTemplate({ dropFee: { price, currency: contractTemplate.dropFee?.currency ?? 'EUR' } })}
                />
              </div>
            ) : (
              <span className="ml-2 text-sm text-muted-foreground">{t('commission_contract_template.drop_fee.free')}</span>
            )}
          </div>
        </div>

        <div>
          <label className="block mb-2 font-medium">{t('commission_contract_template.renewal_fee_label')}</label>
          <div className="flex items-center gap-4 mb-2">
            <Toggle
              label={isRenewalFeePaid ? t('commission_contract_template.renewal_fee.paid') || '' : t('commission_contract_template.renewal_fee.free') || ''}
              defaultValue={isRenewalFeePaid}
              onChange={(checked: boolean) => {
                setIsRenewalFeePaid(checked);
                if (!checked) {
                  updateContractTemplate({ renewalFee: { price: 0, currency: contractTemplate.renewalFee?.currency ?? 'EUR' } });
                }
              }}
            />
            {isRenewalFeePaid ? (
              <div className="flex items-center gap-2 w-full max-w-xs">
                <PriceField
                  label={''}
                  price={contractTemplate.renewalFee?.price ?? 0}
                  currency={contractTemplate.renewalFee?.currency ?? 'EUR'}
                  currencies={CONFIG.SUPPORTED_CURRENCIES}
                  onCurrencyChange={currency => updateContractTemplate({ renewalFee: { price: contractTemplate.renewalFee?.price ?? 0, currency } })}
                  onPriceChange={price => updateContractTemplate({ renewalFee: { price, currency: contractTemplate.renewalFee?.currency ?? 'EUR' } })}
                />
              </div>
            ) : (
              <span className="ml-2 text-sm text-muted-foreground">{t('commission_contract_template.renewal_fee.free')}</span>
            )}
          </div>
        </div>

        <PaymentsNotice />
      </div>
    </CardV2>
  );
}
